var _style, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaresourceonlyheart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 116 103",
    style: {
      enableBackground: "new 0 0 116 103"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#9D60A7;}\n\t.st1{fill:#D0AAD0;}\n\t.st2{fill:#833895;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.6,28.8c-6.9,17.4-1.9,43.4,8.9,57.8c4.6-8.7,13.8-16.4,22.1-21.9c26.2-17.5,34.5-43.3,21.7-57.5 C98.2-5.3,68.5-1.2,56.6,28.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.3,24.9c-11.8,18,1.9,39.8,24.6,51.3C54.2,88.5,64.7,94.4,73,102.5c10.6-34.1,0.5-55-9.7-67.6 C43.5,10,14.3,11.1,5.3,24.9L5.3,24.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M63.4,34.9c-2-2.5-4.1-4.8-6.4-6.9c-0.1,0.3-0.2,0.5-0.4,0.8c-6.9,17.4-1.9,43.4,8.9,57.8 c2.8-5.2,7.1-10,12-14.2C77,58.7,72.1,45.5,63.4,34.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaresourceonlyheart);
export default __webpack_public_path__ + "static/media/caresourceonlyheart.1ae97786cb43828e5759a8a17c2d5a18.svg";
export { ForwardRef as ReactComponent };